import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import addPv from '@/plugins/addPv/addPv';
import appShareInfo from '@/plugins/ShareInfo/appShareInfo';
import wxShareInfo from '@/plugins/ShareInfo/wxShareInfo';
import routerThen from '@/plugins/routerThen/routerThen';
import AutoCachePage from '@/mixins/auto-cache-page';
import vConsole from 'vconsole';
import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false;

VueClipboard.config.autoSetContainer = true;
Vue.use(VueClipboard);

const devConsole =
  process.env.VUE_APP_NO_CONSOLE === 'true' ? 'no-console' : new vConsole();
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
// 全局注册vue自定义插件
Vue.use(addPv)
  .use(appShareInfo)
  .use(wxShareInfo)
  .use(routerThen, {
    router,
  });
// 全局混入vue mixin
Vue.mixin(AutoCachePage);
